<template>
  <div>
    <form role="form" :id="`${orgType}-form`">
      <div class="flex flex-col">
        <label class="flex">
          <input type="radio" :name="`${orgType}_memberships`" v-model="setting" :value="`${orgType}_disabled`" :aria-labelledby="`${orgType}-0-label`" :aria-describedby="`${orgType}-0-description`">
          <div class="m-l-m flex flex-col">
              <span :id="`${orgType}-0-label`" class="font-semi">
                Disabled
              </span>
            <p :id="`${orgType}-0-description`" class="font-normal m-b-none">
              Do not collect {{ orgName }} information
            </p>
          </div>
        </label>
        <label class="flex m-t-m">
          <input type="radio" :name="`${orgType}_memberships`" v-model="setting" :value="`${orgType}_optional`" :aria-labelledby="`${orgType}-1-label`" :aria-describedby="`${orgType}-1-description`">
          <div class="m-l-m flex flex-col">
              <span :id="`${orgType}-1-label`" class="font-semi">
                Optional
              </span>
            <p :id="`${orgType}-1-description`" class="font-normal m-b-none" v-if="verifiesWithApi">
              Registrants may enter a {{ orgName }} membership number. If they do, it is verified with {{ orgName }}, but it is not required to finish registration
            </p>
            <p :id="`${orgType}-1-description`" class="font-normal m-b-none" v-else>
              {{ orgName }} information can be entered, but it is not required to finish registration for the team
            </p>
          </div>
        </label>
        <label class="flex m-t-m">
          <input type="radio" :name="`${orgType}_memberships`" v-model="setting" :value="`${orgType}_require_id_and_expires`" :aria-labelledby="`${orgType}-3-label`" :aria-describedby="`${orgType}-3-description`">
          <div class="m-l-m flex flex-col">
              <span :id="`${orgType}-3-label`" class="font-semi">
                {{ verifiesWithApi ? 'Required' : 'Require id and expiration' }}
              </span>
            <p :id="`${orgType}-3-description`" class="font-normal m-b-none" v-if="verifiesWithApi">
              Registrants must enter a {{ orgName }} membership number that {{ orgName }} reports as active for the current season
            </p>
            <p :id="`${orgType}-3-description`" class="font-normal m-b-none" v-else>
              {{ orgName }} id and expiration date must be entered to register for the team
            </p>
          </div>
        </label>
        <label class="flex m-t-m" v-if="!verifiesWithApi || setting === `${orgType}_require_all`">
          <input type="radio" :name="`${orgType}_memberships`" v-model="setting" :value="`${orgType}_require_all`" :aria-labelledby="`${orgType}-2-label`" :aria-describedby="`${orgType}-2-description`">
          <div class="m-l-m flex flex-col">
              <span :id="`${orgType}-2-label`" class="font-semi">
                Require all info (id, expiration, screenshot of card)
              </span>
            <p :id="`${orgType}-2-description`" class="font-normal m-b-none" v-if="verifiesWithApi">
              Legacy setting. Membership numbers are now verified with {{ orgName }} directly, so this behaves the same as Required and no photo is collected
            </p>
            <p :id="`${orgType}-2-description`" class="font-normal m-b-none" v-else>
              {{ orgName }} information must be entered to register and photo uploaded of membership card
            </p>
          </div>
        </label>
        <label class="flex m-t-m">
          <input type="radio" :name="`${orgType}_memberships`" v-model="setting" :value="`${orgType}_invisible`" :aria-labelledby="`${orgType}-4-label`" :aria-describedby="`${orgType}-4-description`">
          <div class="m-l-m flex flex-col">
              <span :id="`${orgType}-4-label`" class="font-semi">
                Invisible (show on wrestler page, but not during registration)
              </span>
            <p :id="`${orgType}-4-description`" class="font-normal m-b-none">
              This setting lets you record {{ orgName }} info behind the scenes, but does not collect it from registrants at registration time
            </p>
          </div>
        </label>
      </div>
      <ladda-button @lbClicked="update" el-class="btn-primary m-t-md" :loading="updating">
        Save
      </ladda-button>
      <div v-if="error">
        <small><span class="text-danger">{{ errorMessage }}</span></small>
      </div>
    </form>
  </div>
</template>
<script>
import LaddaButton from '../../shared/ladda_button.vue';
import { errorableMix } from './mixins/errorable_mix';

export default {
  name: 'insurance-card-settings',
  components: { LaddaButton },
  mixins: [errorableMix],
  props: {
    initialSetting: {
      type: String,
      required: true,
    },
    teamId: {
      type: Number,
      required: true,
    },
    orgType: {
      type: String,
      required: true,
      validator(value) {
        return ['usaw', 'aau'].includes(value);
      },
    },
    orgName: {
      type: String,
      required: true,
    },
    // True when membership numbers for this org are verified against its API
    // (USAW with USAW_API_MODE live/mock). Hides the photo option and rewords the rest.
    verifiesWithApi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      setting: null,
      updating: false,
    };
  },
  mounted() {
    this.setting = this.initialSetting;
  },
  methods: {
    update: _.throttle(function () {
      if (this.updating) {
        return;
      }

      const vm = this;
      vm.updating = true;
      const url = vm.$apiService.teamUrl(this.teamId);
      const data = {
        team: {
          [`${this.orgType}_memberships`]: this.setting,
        },
      };
      axios.put(url, data)
        .then((response) => {
          vm.$notificationManager.emit('show-toast', 'Settings saved', true);
          vm.updating = false;
          vm.$notificationManager.emit('potential-walkthrough-change');
        })
        .catch((error) => {
          vm.saving = false;
          vm.errorMessage = `Error: ${error.toString()}`;
          vm.error = true;
        });
    }, 500),
  },
};
</script>
